(function () {
    'use strict';

    angular
        .module('app.home')
        .component('sc3AtAGlance', {
            templateUrl: 'app/home/at-a-glance/at-a-glance.component.html',
            controller: AtAGlanceComponent,
            bindings: { member: '<' }
        });

    var noop = angular.noop;

    AtAGlanceComponent.$inject = ['managementGroups', '$state', 'user', 'memberLookupModal', 'clubMembershipLevelType', 'lowHandicapModal', 'cancelSubscriptionModal', 'Member', 'home_resources', 'alert'];
    function AtAGlanceComponent(managementGroups, $state, user, memberLookupModal, clubMembershipLevelType, lowHandicapModal, cancelSubscriptionModal, Member, resources, alert) {
        var ctrl = this;
        Object.defineProperty(ctrl, 'canRenew', { get: canRenew });
        Object.defineProperty(ctrl, 'hasPendingTransfer', { get: hasPendingTransfer });
        ctrl.isOntario = user.clubManagementGroupId === 8;
        ctrl.getLogo = getLogo;
        ctrl.showMemberLookup = showMemberLookup;
        ctrl.showCancelSubscriptionModal2 = showCancelSubscriptionModal2;
        ctrl.showLowHandicapModal = showLowHandicapModal;
        ctrl.allowScorePosting = user.allowScorePosting;
        ctrl.isClubManagingUpgrades = user.isClubManagingUpgrades;
        ctrl.isWinterHandicapDisplayed = user.isWinterHandicapDisplayed;
        ctrl.user = user;

        ///////////////////////////////////////////////

        function showCancelSubscriptionModal2() {

            var now = new Date();
            var renewDate = ctrl.member.subscriptionRenewsOn;

            if (renewDate > now)
                cancelSubscriptionModal().result.then(cancelSubscription).catch(noop);

            function cancelSubscription() {                
                var user = ctrl.user;
                Member.cancelSubscription({ id: user.id }, success, error, true);

                function success(response) {
                    ctrl.member.subscriptionRenewsOn = null;
                    alert.success(resources.cancelSubscriptionSucceeded);
                }
                function error() {
                    alert.error(resources.cancelSubscriptionFailed);
                }
            }
        }

        function getLogo() {
            var meta = managementGroups.$metadata,
                managementGroup = meta[ctrl.member.clubManagementGroup];
            return managementGroup && managementGroup.logo || meta.GolfCanada.logo;
        }

        function showLowHandicapModal(member) {
            lowHandicapModal(member).result.catch(noop);
        }

        function showMemberLookup() {
            memberLookupModal().result.then(navigate, noop);

            function navigate(member) {
                $state.go('scoring', { individualId: member.individualId });
            }
        }
        function canRenew() {
            return ctrl.member.membershipType !== clubMembershipLevelType.Default;
        }
        function hasPendingTransfer() {
            return ctrl.member.transferRequestDate && ctrl.member.transferClubName;
        }
    }
})();